import { useCallback, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { usersAccountMappingLoad } from 'portal/store/usersAccountMappings/actions'

export const useUsersAccountMappingsLoader = (
  userIds: string[],
  filteredProjects: any
) => {
  const dispatch = useDispatch()

  const { loading, error, users } = useSelector((state: any) => {
    return (
      state.usersAccountMappings || {
        loading: false,
        error: null,
        users: {}
      }
    )
  })

  // Memoize the stable key based on sorted userIds
  const userIdsKey = useMemo(
    () => (userIds && userIds.length > 0 ? [...userIds].sort().join(',') : ''),
    [userIds]
  )

  // Memoize hasProjects to avoid unnecessary re-renders
  const hasProjects = useMemo(
    () => filteredProjects && filteredProjects.length > 0,
    [filteredProjects]
  )

  useEffect(() => {
    // Early returns for invalid states
    if (!userIdsKey || loading || !hasProjects) {
      return
    }

    dispatch(usersAccountMappingLoad(userIds))
  }, [dispatch, userIdsKey, userIds, loading, hasProjects])

  const reload = useCallback(() => {
    if (!userIdsKey || loading || !hasProjects) {
      return
    }
    dispatch(usersAccountMappingLoad(userIds))
  }, [dispatch, userIdsKey, userIds, loading, hasProjects])

  return {
    loading,
    error,
    users,
    reload
  }
}
